export const formatDate = (timestamp: number) =>
  new Date(timestamp).toLocaleString();

export const formatNumber = (num: string, decimals: number = 8) =>
  parseFloat(num).toFixed(decimals);


